const MOJIBAKE_PAIRS: Array<[string, string]> = [
  ['NÃƒÂ£o', 'Não'],
  ['UsuÃƒÂ¡rio', 'Usuário'],
  ['NutriÃƒÂ§ÃƒÂ£o', 'Nutrição'],
  ['MovimentaÃƒÂ§ÃƒÂµes', 'Movimentações'],
  ['MovimentaÃƒÂ§ÃƒÂ£o', 'Movimentação'],
  ['ReferÃƒÂªncia', 'Referência'],
  ['TransferÃƒÂªncia', 'Transferência'],
  ['OperaÃƒÂ§ÃƒÂµes', 'Operações'],
  ['aÃƒÂ§ÃƒÂ£o', 'ação'],
  ['informaÃƒÂ§ÃƒÂ£o', 'informação'],
  ['excluÃƒÂ­do', 'excluído'],
  ['disponÃƒÂ­vel', 'disponível'],
  ['ÃƒÂ¡', 'á'],
  ['Ãƒ ', 'à'],
  ['ÃƒÂ¢', 'â'],
  ['ÃƒÂ£', 'ã'],
  ['ÃƒÂ¤', 'ä'],
  ['ÃƒÂ©', 'é'],
  ['ÃƒÂª', 'ê'],
  ['ÃƒÂ­', 'í'],
  ['ÃƒÂ³', 'ó'],
  ['ÃƒÂ´', 'ô'],
  ['ÃƒÂµ', 'õ'],
  ['ÃƒÂº', 'ú'],
  ['ÃƒÂ§', 'ç'],
  ['Ã¡', 'á'],
  ['Ã ', 'à'],
  ['Ã¢', 'â'],
  ['Ã£', 'ã'],
  ['Ã¤', 'ä'],
  ['Ã©', 'é'],
  ['Ãª', 'ê'],
  ['Ã­', 'í'],
  ['Ã³', 'ó'],
  ['Ã´', 'ô'],
  ['Ãµ', 'õ'],
  ['Ãº', 'ú'],
  ['Ã§', 'ç'],
  ['â€¦', '...'],
  ['ââ‚¬Â¦', '...'],
  ['â€”', '-'],
  ['â€“', '-'],
  ['⬦', '...'],
  ['Â·', '·'],
];

function compactSpaces(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

function looksCorrupted(value: string): boolean {
  return (
    value.includes('Ã') ||
    value.includes('Â') ||
    value.includes('Ã¢â‚¬') ||
    value.includes('â€¦') ||
    value.includes('â€”') ||
    value.includes('â€“') ||
    value.includes('â€¢') ||
    value.includes('\uFFFD') ||
    value.includes('ï¿½')
  );
}

function applyExplicitPairs(value: string): string {
  let normalized = value;

  for (const [from, to] of MOJIBAKE_PAIRS) {
    normalized = normalized.split(from).join(to);
  }

  return normalized;
}

export function repairVisibleText(value: string): string {
  if (!looksCorrupted(value)) {
    return value;
  }

  const directlyRepaired = applyExplicitPairs(value);
  if (!looksCorrupted(directlyRepaired)) {
    return directlyRepaired;
  }

  let normalized = value;

  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      const bytes = Uint8Array.from(
        Array.from(normalized).map((char) => char.charCodeAt(0) & 0xff),
      );
      const decoded = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
      if (!decoded || decoded === normalized || decoded.includes('\uFFFD')) {
        break;
      }

      normalized = decoded;
      if (!looksCorrupted(normalized)) {
        break;
      }
    } catch {
      normalized = value;
      break;
    }
  }

  const decodedRepaired = applyExplicitPairs(normalized);
  normalized =
    decodedRepaired.length <= directlyRepaired.length + 4
      ? decodedRepaired
      : directlyRepaired;

  return normalized
    .replace(/\u2026/g, '...')
    .replace(/â€¦/g, '...')
    .replace(/â€”|â€“/g, '-')
    .replace(/⬦/g, '...')
    .replace(/Â·/g, '·');
}

export function normalizePortugueseText(value: string): string {
  return compactSpaces(repairVisibleText(value));
}
